import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

import { TRoomsSearchParams } from '@/entities/room'

import { useRoomsQuery } from '../api/get-rooms'
import { useRoomsCountQuery } from '../api/get-rooms-count'

type Props = {
  filters: TRoomsSearchParams
}

export const useRooms = ({ filters }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useRoomsQuery({
    filters,
  })

  const { roomCount } = useRoomsCountQuery({
    filters,
  })

  const { rooms, airbridgeEvent, isFirstPage } = data
  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage()
    }
  }, [inView])

  return {
    airbridgeEvent,
    rooms,
    roomCount,
    ref,
    isFirstPage,
  }
}
